<script setup>
// import { storeToRefs } from 'pinia';
import { ref, computed, onMounted, nextTick, watch } from 'vue'
import { useRoute } from 'vue-router'
// import { useStageStore } from '../../stores/form'
import { useStageStore } from '../../stores/stage'
// import { useLanguageStore } from '../../stores/language'
import { useConfigStore } from '../../stores/config';
import { useI18n } from 'vue-i18n'

// const langStore = useLanguageStore()
const configStore = useConfigStore()
const { t } = useI18n()
// const { current, defaultLanguage } = storeToRefs(langStore)
const props = defineProps(['data','active','editMode'])
const node = ref(null)
const nodeId = ref(null)
const nodeText = ref("")
const showNode = ref(false)
const cssClass = ref('')

const route = useRoute()
const formStore = useStageStore()

const currentId = ref(null)
const nodeFill = ref('#007bff')
const nodeFillDisabled = ref('#cccccc')
const pathName = ref('')
const answerExists = ref(false)

const svgNodeFill = computed(() => {
  return nodeFill.value
})

const hasMapAccess = computed(() => {
  return props.data?.access?.map
})
const hasQuestionAccess = computed(() => {
  return props.data?.access?.question
})
const hasQuestionAccessAllowedByRelations = computed(() => {
  return props.data?.access?.questionAccessAllowedByRelations
})

const getPathColor = (elem) => {
  if (elem.id === 0 ) {
    nodeFill.value = "#000"
  } else {
    if (elem.node.pathType !== null) {
      const theme = formStore.getPathById(elem.node.pathType)[0]
      if (theme) {
        nodeFill.value = theme.color

        if (theme?.colorDisabled) {
          nodeFillDisabled.value = theme.colorDisabled
        }
      } else {
        nodeFill.value = "#000"
      }
    } else {
      nodeFill.value = "#000"
    }
  }
}

const getPathName = (elem) => {
  pathName.value = formStore.getPathDetailsByStageId(elem.id)[0].name[formStore.language]
}

const getAnswerGivenStatus = (elem) => {
  answerExists.value = formStore.answerExists(elem.id)
}

const showActiveStage = (elem) => {
  cssClass.value = elem.id == route.params.id ? 'active' : ''

  cssClass.value = cssClass.value + (hasMapAccess.value ? '' : ' no-map-access')
  cssClass.value = cssClass.value + (hasQuestionAccess.value ? '' : ' no-question-access')
  cssClass.value = cssClass.value + (hasQuestionAccessAllowedByRelations.value ? '' : ' no-question-access-allowed-by-relations')
}

// const halfTextLength = computed(() => {
//   let length = 0
//   if (nodeText.value) length = nodeText.value.length / 2.5
//   return `-${length}ch`
// })

const getTextSpans = computed(() => {
  if (nodeText.value) {
    return nodeText.value.replace(/.{20}\S*\s+/g, "$&@").split(/\s+@/)
  }
})


onMounted(() => {
  currentId.value = route.params.id

  nextTick(() => {
    node.value = props.data.node
    nodeId.value = props.data.id
    nodeText.value = props.data.title[formStore.language] !== undefined ? props.data.title[formStore.language] : props.data.title[formStore.language]

    getPathColor(props.data)
    getPathName(props.data)
    getAnswerGivenStatus(props.data)
    showActiveStage(props.data)

    showNode.value = true
    if (props.editMode === 'stages') {
      if (nodeId.value === parseFloat(route.params.id)) {
        nodeFill.value = '#28a745'
      }
    }
  })
})

watch(route, (from, to) => {
  if (props.editMode === 'stages') {
    nextTick(() => {
      if (nodeId.value === parseFloat(route.params.id)) {
        nodeFill.value = '#28a745'
      }  else {
        getPathColor(props.data)
      }

      getPathName(props.data)

    })
  }

  getAnswerGivenStatus(props.data)
  showActiveStage(props.data)
})
</script>

<template>
  <g v-if="showNode" :aria-labelledby="`graphic-text-${nodeId} desc-${nodeId}`" :class="`stage stage-done-${answerExists} ${cssClass}`" :id="`map-dot-${nodeId}`">
    <circle
        class="outer-circle"
        :cx="node.location.cx"
        :cy="node.location.cy"
        r="20"
        fill="white"
        :stroke="svgNodeFill"
        stroke-width="2"
    />
    <circle
        class="inner-circle"
        :cx="node.location.cx"
        :cy="node.location.cy"
        r="15"
        :fill="hasMapAccess ? svgNodeFill : nodeFillDisabled"
        dominant-baseline="middle"
        text-anchor="middle"
        :id="`circle-node-${nodeId}`"
        :stroke="svgNodeFill"
        stroke-width="0"
    />

    <svg 
      v-if="answerExists" 
      class="done-mark" 
      :x="node.location.cx - 8" 
      :y="node.location.cy - 7"
    >
      <path d="M5.59 10.58 1.42 6.41 0 7.82l5.59 5.59 12-12L16.18 0Z"/>
    </svg>

    <text
        v-show="configStore.getShowNodeName"
        :y="node.location.cy + 22"
        text-anchor="middle"
        class="small node-name"
    >

      <tspan 
        v-for="(span,idx) in getTextSpans" 
        :x="node.location.cx" 
        :dy="15 + idx" 
        :key="idx" 
        :id="`graphic-text-${nodeId}`"
        class="text-row"
        aria-hidden="true"
      >
        {{ span }}
      </tspan>

      <desc :id="`desc-${nodeId}`">
        <tspan v-if="answerExists">{{ t('answer-given')}}.</tspan>
        {{ t('move-to-stage')}} {{ nodeId }}.
        {{ t('topic') }} {{ pathName }}.
      </desc>
    </text>
  </g>

</template>